export const parseExportFileName = (exportType: string) => {
  switch (exportType) {
    case 'active':
      return 'Active_Employees_List';
    case 'certsTags':
      return 'Employees_Certs_Tags';
    default:
      return exportType;
  }
};
